export { default } from "ember-stereo/-private/utils/object-cache";
